const initialState = {
    randomKey: '0',
    open: false,
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CONFIGURED_DIALOG__CLOSE':
            return { ...state, open: false };
        case 'CONFIGURED_DIALOG__OPEN':
            return {
                ...state,
                open: true,
                randomKey: Math.random().toString(),
            };
        default:
            return state;
    }
};
